import React from "react";

export default function Medal3() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 1105.2 1105.2"
      version="1.1"
      viewBox="0 0 1105.2 1105.2"
      xmlSpace="preserve"
    >
      <radialGradient
        id="SVGID_1_"
        cx="1029.836"
        cy="532.948"
        r="35.917"
        gradientTransform="translate(-15292.049 -7647.128) scale(15.3856)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#222021"></stop>
        <stop offset="0.643" stopColor="#A29D9F"></stop>
        <stop offset="1" stopColor="#FFF"></stop>
      </radialGradient>
      <path
        fill="url(#SVGID_1_)"
        d="M1105.2 552.6c0 305.2-247.4 552.6-552.6 552.6S0 857.8 0 552.6 247.4 0 552.6 0s552.6 247.4 552.6 552.6z"
      ></path>
      <radialGradient
        id="SVGID_00000103259559202028241250000002194434274997720241_"
        cx="1069.85"
        cy="448.495"
        r="6.487"
        gradientTransform="rotate(180 8599.292 3792.182) scale(15.3856)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D07D67"></stop>
        <stop offset="0.026" stopColor="#C17662"></stop>
        <stop offset="0.161" stopColor="#84544D"></stop>
        <stop offset="0.295" stopColor="#563B3A"></stop>
        <stop offset="0.425" stopColor="#352729"></stop>
        <stop offset="0.552" stopColor="#1D181B"></stop>
        <stop offset="0.674" stopColor="#0D0B0D"></stop>
        <stop offset="0.79" stopColor="#030405"></stop>
        <stop offset="0.89" stopColor="#020203"></stop>
      </radialGradient>
      <path
        fill="url(#SVGID_00000103259559202028241250000002194434274997720241_)"
        d="M638.5 684c0-55.1 44.7-99.8 99.8-99.8s99.8 44.7 99.8 99.8-44.7 99.8-99.8 99.8c-55.1.1-99.8-44.6-99.8-99.8z"
      ></path>
      <linearGradient
        id="SVGID_00000152263127372180800390000009028392054284946858_"
        x1="169.221"
        x2="902.971"
        y1="-80.203"
        y2="474.293"
        gradientTransform="translate(-56.55 272.696)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#5C1F1D"></stop>
        <stop offset="0.242" stopColor="#BA5C3B"></stop>
        <stop offset="0.497" stopColor="#E4C8A9"></stop>
        <stop offset="0.721" stopColor="#BA5C3B"></stop>
        <stop offset="0.739" stopColor="#B15639"></stop>
        <stop offset="0.824" stopColor="#8B3D2E"></stop>
        <stop offset="0.899" stopColor="#712C25"></stop>
        <stop offset="0.961" stopColor="#61231F"></stop>
        <stop offset="1" stopColor="#5C1F1D"></stop>
      </linearGradient>
      <path
        fill="url(#SVGID_00000152263127372180800390000009028392054284946858_)"
        d="M1017.3 525c0 256.6-208 464.6-464.7 464.6C296 989.6 88 781.6 88 525S296 60.4 552.6 60.4c256.7-.1 464.7 208 464.7 464.6z"
      ></path>
      <linearGradient
        id="SVGID_00000173122702619897482870000014014161302246175138_"
        x1="909.76"
        x2="315.214"
        y1="-90.499"
        y2="587.723"
        gradientTransform="translate(-56.55 272.696)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#5C1F1D"></stop>
        <stop offset="0.242" stopColor="#BA5C3B"></stop>
        <stop offset="0.497" stopColor="#E4C8A9"></stop>
        <stop offset="0.721" stopColor="#BA5C3B"></stop>
        <stop offset="0.739" stopColor="#B15639"></stop>
        <stop offset="0.824" stopColor="#8B3D2E"></stop>
        <stop offset="0.899" stopColor="#712C25"></stop>
        <stop offset="0.961" stopColor="#61231F"></stop>
        <stop offset="1" stopColor="#5C1F1D"></stop>
      </linearGradient>
      <path
        fill="url(#SVGID_00000173122702619897482870000014014161302246175138_)"
        d="M1008.5 525c0 251.7-204.1 455.8-455.8 455.8-251.8 0-455.8-204.1-455.8-455.8S301 69.2 552.7 69.2c251.8-.1 455.8 204 455.8 455.8z"
      ></path>
      <linearGradient
        id="SVGID_00000158729308343879607690000008605961560323790000_"
        x1="169.236"
        x2="902.978"
        y1="-80.206"
        y2="474.284"
        gradientTransform="translate(-56.55 272.696)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#5C1F1D"></stop>
        <stop offset="0.242" stopColor="#BA5C3B"></stop>
        <stop offset="0.497" stopColor="#E4C8A9"></stop>
        <stop offset="0.721" stopColor="#BA5C3B"></stop>
        <stop offset="0.739" stopColor="#B15639"></stop>
        <stop offset="0.824" stopColor="#8B3D2E"></stop>
        <stop offset="0.899" stopColor="#712C25"></stop>
        <stop offset="0.961" stopColor="#61231F"></stop>
        <stop offset="1" stopColor="#5C1F1D"></stop>
      </linearGradient>
      <path
        fill="url(#SVGID_00000158729308343879607690000008605961560323790000_)"
        d="M968.9 525c0 229.9-186.3 416.2-416.2 416.2-229.8 0-416.2-186.3-416.2-416.2 0-229.8 186.3-416.1 416.2-416.1 229.8-.1 416.2 186.2 416.2 416.1z"
      ></path>
      <radialGradient
        id="SVGID_00000135677348044944292730000013314263231314963331_"
        cx="1029.84"
        cy="531.154"
        r="26.072"
        gradientTransform="translate(-15292.049 -7647.128) scale(15.3856)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.288" stopColor="#DDDFDE"></stop>
        <stop offset="0.352" stopColor="#CACCCC"></stop>
        <stop offset="0.476" stopColor="#9D9DA0"></stop>
        <stop offset="0.645" stopColor="#5E5D62"></stop>
        <stop offset="0.853" stopColor="#1B1D21"></stop>
        <stop offset="0.949" stopColor="#020203"></stop>
        <stop offset="0.972" stopColor="#FFF"></stop>
        <stop offset="1" stopColor="#020203"></stop>
      </radialGradient>
      <path
        fill="url(#SVGID_00000135677348044944292730000013314263231314963331_)"
        d="M953.8 525c0 221.5-179.6 401.1-401.2 401.1-221.5 0-401.1-179.6-401.1-401.1s179.6-401.1 401.1-401.1c221.7 0 401.2 179.5 401.2 401.1z"
        enableBackground="new"
        opacity="0.2"
      ></path>
      <linearGradient
        id="SVGID_00000109008470506806425460000007537795169580094849_"
        x1="544.55"
        x2="544.55"
        y1="-106.395"
        y2="634.978"
        gradientTransform="translate(0 262)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#5C1F1D"></stop>
        <stop offset="0.242" stopColor="#BA5C3B"></stop>
        <stop offset="0.497" stopColor="#E4C8A9"></stop>
        <stop offset="0.721" stopColor="#BA5C3B"></stop>
        <stop offset="0.739" stopColor="#B15639"></stop>
        <stop offset="0.824" stopColor="#8B3D2E"></stop>
        <stop offset="0.899" stopColor="#712C25"></stop>
        <stop offset="0.961" stopColor="#61231F"></stop>
        <stop offset="1" stopColor="#5C1F1D"></stop>
      </linearGradient>
      <path
        fill="url(#SVGID_00000109008470506806425460000007537795169580094849_)"
        d="M900.3 415c-2.2-7.5-4.9-14.5-7.3-21.2-2.5-6.7-4.8-13.2-7.5-19.1-5.5-11.9-10.5-22.5-15.5-31.5-10.4-18-18.8-31.1-25.2-39.3-6.3-8.3-9.4-12.4-9.4-12.4s-1.8-2.5-5.2-6.5-8.5-9.7-14.6-16.4c-3.1-3.3-6.4-7-10.1-10.6-3.8-3.5-7.8-7.2-12-11.1-4.2-3.8-8.6-7.7-13.1-11.6-4.7-3.7-9.5-7.4-14.4-11s-9.7-7.2-14.6-10.6c-5-3.2-10-6.3-14.8-9.2-4.9-2.9-9.7-5.7-14.1-8.4-4.6-2.5-9.1-4.6-13.1-6.6-8.2-4-15-7.2-19.9-9.4-5-1.9-7.8-3-7.8-3s-8.2-3.2-20.7-7.6c-6.2-2.3-13.7-4.2-21.7-6.4-8-1.9-16.5-4.4-25.2-5.8-8.7-1.5-17.4-2.8-25.5-4-8.2-1.3-15.8-1.4-22.3-1.9-13.1-.7-21.9-.9-21.9-.9h-.2s-10.8.2-26.9 1.2c-4 .3-8.4.4-13 1-4.6.7-9.5 1.4-14.5 2.1-10.1 1.5-20.7 3.1-31.2 5.9-5.3 1.4-10.5 2.8-15.7 4.1-5.2 1.4-10.2 2.8-15 4.6-9.6 3.3-18.5 6.6-26.1 9.6-7.5 3.1-13.6 6.1-17.8 8.1-4.3 2.1-6.7 3.3-6.7 3.3s-5.6 2.7-11.1 5.6c-5.3 3.2-10.7 6.3-10.7 6.3s-5.3 3.2-10.6 6.5c-2.6 1.7-5.2 3.3-7.2 4.6-2 1.2-3.2 2.2-3.2 2.2s-5 3.6-10 7.3c-4.9 3.7-9.9 7.4-9.9 7.4s-1.2.9-3 2.4c-1.9 1.4-4.3 3.3-6.6 5.4l-9.2 8.2s-4.6 4.2-9.1 8.4c-4.6 4.1-8.8 8.7-8.8 8.7s-4.2 4.5-8.4 9.1l-8.2 9.2s-.5.6-1.4 1.6-2.2 2.5-3.6 4.3c-2.9 3.7-6.6 8.6-10.3 13.6s-7.4 10-10 13.8c-2.5 3.9-4.2 6.6-4.2 6.6s-3.2 5.3-6.5 10.6c-3.1 5.4-6.3 10.7-6.3 10.7s-.8 1.3-1.9 3.4c-1.1 2.1-2.5 4.9-3.8 7.7l-5.4 11.2s-1.3 2.9-3.3 7c-2.1 4.2-4.4 10-6.5 15.8-4.4 11.6-8.4 23.4-8.4 23.4s-.5 1.5-1.2 4.1c-.7 2.7-1.8 6.4-3 10.9-2.3 9.1-5.6 21.1-7.3 33.4-1.9 12.3-4 24.6-4.2 33.8-.5 9.2-.9 15.4-.9 15.4l-.3 6.9-.2 6.8v.2s.2 9 .9 22.6c.3 13.6 3.1 31.7 6.2 49.7 1.8 9 4.2 17.8 6.3 26.1 1.1 4.2 2.2 8.2 3.3 11.9 1.3 3.7 2.5 7.2 3.6 10.4 4.6 12.9 8 21.5 8 21.5s.7 2.2 2.5 5.8c1.7 3.6 4.1 8.8 7.1 15 5.7 12.6 15.1 28.2 24.9 43.6 5.2 7.5 10.6 14.8 15.8 21.6 5.1 6.9 10.3 12.9 14.9 17.9 9.1 10.1 15.4 16.7 15.4 16.7s6.5 6.3 16.7 15.4c5 4.6 11 9.9 17.9 14.9 6.8 5.1 14.1 10.6 21.6 15.8 15.4 9.8 31 19.2 43.6 24.9 6.2 3.1 11.3 5.4 15 7.1 3.6 1.8 5.8 2.5 5.8 2.5s8.5 3.4 21.5 8c3.2 1.1 6.7 2.3 10.5 3.6 3.8 1.1 7.8 2.1 11.9 3.3 8.3 2.1 17.2 4.5 26.2 6.3 18 3.1 36.1 5.8 49.7 6.2 13.6.8 22.7.9 22.7.9h.2s5.1-.2 10.3-.3c5.1-.2 10.3-.4 10.3-.4s2.5-.2 6.9-.5c4.4-.2 10.8-.6 18.3-1.7 7.6-1.1 16.4-2.4 25.8-4 9.4-1.8 19.3-4.5 29.2-7.1 9.9-2.4 19.5-6.1 28.6-9.4 9-3.3 17.3-6.5 24.2-9.9 13.9-6.5 22.9-11.2 22.9-11.2s13.4-7.3 32.5-19.7c9.2-6.7 20-14.4 30.9-23.6 10.6-9.5 22.1-19.4 32.1-30.8 5.1-5.6 10.2-11.2 15-16.9 4.6-5.9 9-11.7 13.3-17.4 8.7-11.2 15.3-22.8 21.3-32.6 6-9.7 9.9-18.4 12.9-24.4 2.8-6 4.5-9.5 4.5-9.5s1.5-2.9 4-9c2.4-6.1 5.9-15.3 10.2-27.7 2.4-6.2 4-13.4 6.1-21.3 1-4 2.1-8.2 3.2-12.6s2.1-9 2.8-13.8c1.6-9.7 3.3-20.2 4.6-31.6.8-11.3 1.5-23.6 1.8-36.5-.7-41.5-7.4-77.7-16.2-107.7zM546.6 523.4c0 .1-.1 0 0 0-.2-.1-.1.2-.6.7.2.4-.4 0-.2.4-.1.1-.3-.1-.2.2-.4-.3-.2.2-.2.2-.2-.2-.4.2-.8 0 0-.1-.3.2-.3.3 0-.3-.5-.3-.7-.1-.1-.3-.1-.2-.2-.1-.1.2 0-.2 0-.2-.2.3 0-.3-.4 0-.1-.4-.4-.6-.5-.4.1-.2 0-.5-.4-.6.3-.3-.3-.1 0-.3 0 0-.3.1-.2 0s.3-.1 0-.2c.2-.1.1-.7-.1-.7l.2-.1.1-.1c-.2-.2.3-.6-.1-.6.3.1 0-.2.2-.1 0 0 .1 0 0-.1l-.1-.1c.2 0 .3 0 .2-.1 0 0 0-.1-.1-.1h.2v-.2c0-.1.1 0 .1 0 .1 0 .2-.1.2-.2-.2-.2.3 0 .2-.1v-.2c-.1-.2.2 0 .1 0 .1.1.2-.2.1-.2 0-.1.3.2.2 0v-.2c.1.1.1.2.1.2s.1 0 .1-.2c.1.1.1.2.1 0-.1-.2 0 0 0 0 0 .1.1.1.1.1.1 0 .7-.1.7-.3 0 0 .1.3.3.2.2-.4.2.2.4-.1.1-.2 0 .3 0 .1 0 0 .2-.3.1-.1v.1s0-.1.1-.2v.2s.1-.1.1-.2v.2s.1 0 .2-.1v.2s.1 0 .2-.1v.3h.2c.1 0 0 .2 0 .2 0 .1.2.1.3.1 0 0-.1.2 0 .1-.1.1.1.2.3.3 0 .1-.2.2 0 .2.1 0-.2.2-.1.2-.1 0 .2-.1.2 0-.2.1-.2.1.2.8.1.8-.5.6-.2.8-.3 0-.2.1-.1.2z"
        enableBackground="new"
        opacity="0.5"
      ></path>
      <path
        fill="#FFF"
        d="M905.1 606.8c8.8-25.2 14.4-52.3 16-81.1 7.4-110-50.7-222.5-139.1-288.7-87.8-67.7-205.7-89.3-303-50.8-5 1.9-9.9 4-14.7 6.1 95.2-34.3 213.6-4.8 301.9 75.9 88.9 79 147.8 209.3 138.9 338.6z"
        opacity="0.1"
      ></path>
      <linearGradient
        id="SVGID_00000154418009859793318310000001021249760377360015_"
        x1="320.04"
        x2="588.682"
        y1="1.025"
        y2="234.435"
        gradientTransform="translate(-56.55 272.696)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#020203"></stop>
        <stop offset="0.569" stopColor="#747076"></stop>
        <stop offset="1" stopColor="#F4F2F3"></stop>
      </linearGradient>
      <path
        fill="url(#SVGID_00000154418009859793318310000001021249760377360015_)"
        d="M831.7 246.5c-71.4-71.5-170-115.7-279-115.7-217.7 0-394.2 176.5-394.2 394.2 0 117.5 51.4 223 132.9 295.2C429.9 540.1 668.1 351 831.7 246.5z"
        enableBackground="new"
        opacity="0.1"
      ></path>
      <g>
        <path
          fill="#020203"
          d="M408.7 764.7c7.9 17.6 5.2 36.4 2.2 37.5-2.2 1-24.7-9.8-32.2-29.1-7.6-19.1 1.2-36.5 4-37 4-.7 18.1 11.1 26 28.6z"
        ></path>
        <linearGradient
          id="SVGID_00000063607079200365077370000001149738038376893619_"
          x1="374.838"
          x2="414.684"
          y1="507.2"
          y2="507.2"
          gradientTransform="translate(0 262)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#EBB794"></stop>
          <stop offset="0.472" stopColor="#682B24"></stop>
          <stop offset="0.609" stopColor="#EBB794"></stop>
          <stop offset="0.793" stopColor="#EBB794"></stop>
          <stop offset="0.957" stopColor="#C87B52"></stop>
          <stop offset="1" stopColor="#BF6C43"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000063607079200365077370000001149738038376893619_)"
          d="M410.5 803.1c-4.3 0-25.3-11.2-32.6-29.7-5.9-14.8-2-28.6 1.1-34.4.9-1.6 2.1-3.5 3.4-3.7h.5c5.2 0 19 12.5 26.5 29.1 6.9 15.4 5.7 31.3 3.5 36.4-.5 1.2-1.1 2-1.8 2.2-.1 0-.3.1-.6.1zm-27.6-66.3h-.2c-.3.1-1.2.9-2.4 3.1-3.7 6.9-6.1 19.6-.9 32.8 7.2 18.3 27.9 28.7 31 28.7h.1s.4-.2.9-1.3c2.1-4.9 3.2-20.2-3.5-35.1-7.9-17.5-21.2-28.2-25-28.2z"
        ></path>
        <path
          fill="#020203"
          d="M369.7 818.3c22.9 3.7 38.8-8.6 38.2-11.5-.6-2.3-19.3-16.6-40-20.9-20.8-4.3-38.8 2.9-39 6.2-.3 4.6 17.8 22.5 40.8 26.2z"
        ></path>
        <linearGradient
          id="SVGID_00000146479762058487593760000006195349050736918945_"
          x1="328.187"
          x2="408.851"
          y1="539.9"
          y2="539.9"
          gradientTransform="translate(0 262)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#EBB794"></stop>
          <stop offset="0.472" stopColor="#682B24"></stop>
          <stop offset="0.609" stopColor="#EBB794"></stop>
          <stop offset="0.793" stopColor="#EBB794"></stop>
          <stop offset="0.957" stopColor="#C87B52"></stop>
          <stop offset="1" stopColor="#BF6C43"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000146479762058487593760000006195349050736918945_)"
          d="M378.3 819.9c-2.9 0-5.8-.2-8.7-.7-13.6-2.2-24.3-9.1-29.5-12.9-7.2-5.4-12.2-11.3-11.9-14.1.2-3.6 12.8-8.3 26.7-8.3 4.5 0 8.9.4 13.3 1.3 20.7 4.3 39.8 18.7 40.6 21.5.2.8-.2 1.6-1 2.7-3.5 4-14.5 10.5-29.5 10.5zm-23.4-34.4c-14.9 0-24.9 5-25 6.8-.4 3.7 17 21.6 40 25.3 2.8.5 5.6.7 8.4.7 13.8 0 24.2-5.7 27.8-9.5.9-1 1.1-1.5 1.1-1.6-1.1-2.3-19.2-16.1-39.3-20.3-4.3-1-8.6-1.4-13-1.4z"
        ></path>
        <path
          fill="#020203"
          d="M373.5 735c4.4 18.4-1.7 36.5-4.7 37.2-2.2.7-21.8-13.3-25.7-33.4-4-20 7.4-35.7 10.2-35.8 4.1-.1 15.7 13.6 20.2 32z"
        ></path>
        <linearGradient
          id="SVGID_00000165200947627730458550000009132068776333066658_"
          x1="341.4"
          x2="375.86"
          y1="475.65"
          y2="475.65"
          gradientTransform="translate(0 262)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#EBB794"></stop>
          <stop offset="0.472" stopColor="#682B24"></stop>
          <stop offset="0.609" stopColor="#EBB794"></stop>
          <stop offset="0.793" stopColor="#EBB794"></stop>
          <stop offset="0.957" stopColor="#C87B52"></stop>
          <stop offset="1" stopColor="#BF6C43"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000165200947627730458550000009132068776333066658_)"
          d="M368.6 773c-3.3 0-22.4-14.1-26.3-34.1-3.1-15.6 3-28.5 7.1-33.7 1.1-1.4 2.6-3 3.9-3 5.1 0 16.7 15 21 32.7 3.8 16.1-.2 31.5-3.2 36.3-.7 1.1-1.4 1.7-2.1 1.9-.2-.1-.3-.1-.4-.1zm-15.3-69.3c-.3 0-1.3.7-2.8 2.7-4.8 6.2-9.3 18.4-6.6 32.1 3.8 19.5 22.4 32.8 24.7 32.8v.8-.8s.4-.1 1.1-1.2c2.9-4.5 6.7-19.4 3-35-4.4-18.1-15.9-31.4-19.4-31.4z"
        ></path>
        <path
          fill="#020203"
          d="M326.5 781.8c21.3 7.1 38.7-2.7 38.7-5.5-.2-2.4-15.4-19.2-34.6-26.5-19.4-7.3-38.1-3.1-38.8.2-1.3 4.3 13.2 24.7 34.7 31.8z"
        ></path>
        <linearGradient
          id="SVGID_00000176038903616544066360000007035986465637476001_"
          x1="290.817"
          x2="365.984"
          y1="503"
          y2="503"
          gradientTransform="translate(0 262)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#EBB794"></stop>
          <stop offset="0.472" stopColor="#682B24"></stop>
          <stop offset="0.609" stopColor="#EBB794"></stop>
          <stop offset="0.793" stopColor="#EBB794"></stop>
          <stop offset="0.957" stopColor="#C87B52"></stop>
          <stop offset="1" stopColor="#BF6C43"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000176038903616544066360000007035986465637476001_)"
          d="M341.9 785.2c-5.3 0-10.6-.9-15.7-2.6-12.7-4.2-21.9-12.6-26.2-17.2-6-6.4-9.8-13-9.1-15.7.6-2.7 8.3-4.9 17.6-4.9 5.3 0 13.4.7 22.4 4.1 19.2 7.4 35 24.4 35.2 27.2-.1 3.1-10.6 9.1-24.2 9.1zm-33.4-38.7c-9.8 0-15.7 2.4-15.9 3.6-1 3.5 12.7 23.7 34.2 30.9 5 1.7 10.1 2.5 15.2 2.5 13.5 0 22.2-5.8 22.4-7.3-.4-2.2-15.4-18.6-34.1-25.7-8.8-3.3-16.7-4-21.8-4z"
        ></path>
        <path
          fill="#020203"
          d="M344.6 700.4c1.2 18.8-7.9 35.7-10.9 35.8-2.3.3-18.8-16.4-19.3-36.8-.6-20.2 13-34 15.8-33.7 4 .7 13.2 16 14.4 34.7z"
        ></path>
        <linearGradient
          id="SVGID_00000078032792397568374940000000457758955949874857_"
          x1="313.481"
          x2="345.502"
          y1="439.05"
          y2="439.05"
          gradientTransform="translate(0 262)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#EBB794"></stop>
          <stop offset="0.472" stopColor="#682B24"></stop>
          <stop offset="0.609" stopColor="#EBB794"></stop>
          <stop offset="0.793" stopColor="#EBB794"></stop>
          <stop offset="0.957" stopColor="#C87B52"></stop>
          <stop offset="1" stopColor="#BF6C43"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000078032792397568374940000000457758955949874857_)"
          d="M333.6 737.1c-3.5 0-19.6-17.8-20.1-37.6-.4-13.8 5.7-25.2 11.6-31.2 1-1 3.4-3.3 5-3.3h.2c5 .8 14 17.3 15.1 35.4 1 16.4-5.6 31-9.3 35.2-.9 1-1.7 1.5-2.4 1.5h-.1zm-3.5-70.5c-.4 0-1.8.8-3.8 2.8-1.9 2-11.6 12.8-11.1 30 .5 19.6 16.2 35.6 18.4 36 .1 0 .5-.2 1.2-1 3.6-4 9.9-18.1 8.9-33.9-1.1-18.6-10.2-33.3-13.6-33.9z"
        ></path>
        <path
          fill="#020203"
          d="M291 739.4c19.5 10.2 38 3.2 38.5.4.3-2.4-11.6-21.2-29.2-31.3-17.7-10.2-36.7-8.8-38-5.7-1.9 4 9 26.3 28.7 36.6z"
        ></path>
        <linearGradient
          id="SVGID_00000087410774348710911710000005304617864687064710_"
          x1="261.321"
          x2="330.305"
          y1="460.6"
          y2="460.6"
          gradientTransform="translate(0 262)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#EBB794"></stop>
          <stop offset="0.472" stopColor="#682B24"></stop>
          <stop offset="0.609" stopColor="#EBB794"></stop>
          <stop offset="0.793" stopColor="#EBB794"></stop>
          <stop offset="0.957" stopColor="#C87B52"></stop>
          <stop offset="1" stopColor="#BF6C43"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000087410774348710911710000005304617864687064710_)"
          d="M312.5 745.6c-7.5 0-15-1.9-21.9-5.5-19.2-10-31.3-32.7-29-37.7 1-2.6 7.9-2.8 10-2.8 4.5 0 16.4.8 29.1 8.1 17.5 10.2 29.9 29.3 29.6 32.2-.5 2.6-8.6 5.7-17.8 5.7zm-40.9-44.3c-5.8 0-8.3 1.2-8.5 1.7-1.5 3.3 8.5 25.3 28.3 35.6 6.6 3.5 13.9 5.3 21.1 5.3 9.7 0 15.9-3.2 16.2-4.3 0-2.2-11.7-20.6-28.8-30.5-12.4-7-23.9-7.8-28.3-7.8z"
        ></path>
        <path
          fill="#020203"
          d="M322.1 662.1c-1.9 18.7-13.5 33.9-16.5 33.6-2.3 0-15.7-19-13-39.2 2.6-20 18.1-31.5 20.8-30.7 3.8 1.2 10.5 17.7 8.7 36.3z"
        ></path>
        <linearGradient
          id="SVGID_00000048485441377320380300000007252623369056702891_"
          x1="291.353"
          x2="323.193"
          y1="398.7"
          y2="398.7"
          gradientTransform="translate(0 262)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#EBB794"></stop>
          <stop offset="0.472" stopColor="#682B24"></stop>
          <stop offset="0.609" stopColor="#EBB794"></stop>
          <stop offset="0.793" stopColor="#EBB794"></stop>
          <stop offset="0.957" stopColor="#C87B52"></stop>
          <stop offset="1" stopColor="#BF6C43"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000048485441377320380300000007252623369056702891_)"
          d="M305.7 696.5h-.1c-.5 0-1.2-.3-2.7-1.9-4.6-5.2-13.4-21.5-11.2-38.2 2.6-20 17.6-31.5 21.3-31.5.2 0 .4 0 .5.1 4.3 1.4 11.2 18 9.4 37.2-1.9 18.7-13.4 34.3-17.2 34.3zm7.4-70c-2.6 0-17.2 10.5-19.7 30-2.6 19.8 10.2 37.6 12.3 38.2 2.5 0 13.7-14.4 15.6-32.8 1.7-18.3-4.9-34.3-8.2-35.4z"
        ></path>
        <path
          fill="#020203"
          d="M263.3 692.2c17.5 13.1 36.6 9 37.6 6.3.7-2.3-7.9-22.6-23.6-35.3-15.8-12.7-34.8-14.3-36.5-11.5-2.4 3.8 4.9 27.4 22.5 40.5z"
        ></path>
        <linearGradient
          id="SVGID_00000003107059100352397120000003055788659537932683_"
          x1="239.536"
          x2="301.738"
          y1="413.85"
          y2="413.85"
          gradientTransform="translate(0 262)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#EBB794"></stop>
          <stop offset="0.472" stopColor="#682B24"></stop>
          <stop offset="0.609" stopColor="#EBB794"></stop>
          <stop offset="0.793" stopColor="#EBB794"></stop>
          <stop offset="0.957" stopColor="#C87B52"></stop>
          <stop offset="1" stopColor="#BF6C43"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000003107059100352397120000003055788659537932683_)"
          d="M289.8 702.1c-5.5 0-16.2-1.2-27-9.3-17.2-12.8-25.6-37.1-22.7-41.6.6-1.1 2.5-1.6 5.4-1.6 6.1 0 19.7 2.7 32.3 12.9 15.6 12.7 24.6 33.4 23.9 36.2-.7 2-5.8 3.4-11.9 3.4zm-44.3-50.8c-2.9 0-3.8.6-4 .8-2 3 4.5 26.2 22.3 39.4 10.4 7.8 20.8 8.9 26 8.9 6.4 0 10-1.6 10.3-2.2.4-2.2-8.1-22.1-23.3-34.4-10.7-8.6-23.7-12.5-31.3-12.5z"
        ></path>
        <path
          fill="#020203"
          d="M305.9 620.8c-4.7 18.1-18.5 31.3-21.4 30.6-2.2-.4-12.5-21.1-6.9-40.6 5.5-19.4 22.5-28.3 25.1-27.1 3.6 1.7 7.8 19 3.2 37.1z"
        ></path>
        <linearGradient
          id="SVGID_00000170961351535715575870000003310809053375417279_"
          x1="275.118"
          x2="308.745"
          y1="355.4"
          y2="355.4"
          gradientTransform="translate(0 262)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#EBB794"></stop>
          <stop offset="0.472" stopColor="#682B24"></stop>
          <stop offset="0.609" stopColor="#EBB794"></stop>
          <stop offset="0.793" stopColor="#EBB794"></stop>
          <stop offset="0.957" stopColor="#C87B52"></stop>
          <stop offset="1" stopColor="#BF6C43"></stop>
        </linearGradient>
        <path
          fill="url(#SVGID_00000170961351535715575870000003310809053375417279_)"
          d="M284.8 652.2c-.2 0-.3 0-.4-.1-.5-.1-1.1-.4-2.3-2.3-3.7-5.9-9.9-23.2-5.3-39.4 5.2-18.3 20.8-27.8 25.3-27.8.4 0 .7.1.9.2 4.1 2 8.5 19.5 3.7 38.2-4.6 17.7-17.9 31.2-21.9 31.2zm17.3-67.9c-3.2 0-18.5 8.6-23.7 26.6-5.5 19.1 4.4 38.7 6.3 39.6h.1c3 0 15.9-12.8 20.3-30 4.6-17.9.4-34.7-2.8-36.2 0 .1-.1 0-.2 0z"
        ></path>
        <g>
          <path
            fill="#020203"
            d="M243.4 641.5c15.3 15.6 34.7 14.5 36.1 12 1-2.1-4.3-23.5-17.9-38.5-13.7-15-32.2-19.5-34.4-16.9-2.9 3.3.8 27.7 16.2 43.4z"
          ></path>
          <linearGradient
            id="SVGID_00000136381965379236388360000012576675620293991097_"
            x1="225.499"
            x2="280.356"
            y1="364.15"
            y2="364.15"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000136381965379236388360000012576675620293991097_)"
            d="M273.2 655.8c-4 0-18-1-30.4-13.7-15-15.3-19.7-40.5-16.2-44.6.5-.6 1.6-1 3.1-1 6.5 0 21.3 5.7 32.5 17.9 13.5 14.9 19.2 36.8 18 39.4-1 1.8-5.6 2-7 2zm-43.5-57.6c-1.2 0-1.7.2-1.8.4-2.4 2.7.6 26.5 16.1 42.3 12 12.3 25.4 13.2 29.2 13.2 3.6 0 5.3-.7 5.5-1 .7-2.1-4.6-23-17.8-37.5-10.8-11.9-25-17.4-31.2-17.4z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M296 577.6c-7.3 17.2-22.9 28.1-25.6 26.9-2.1-.7-9.2-22.8-.9-41.2 8.3-18.3 26.3-24.5 28.7-22.9 3.4 2.3 5 20-2.2 37.2z"
          ></path>
          <linearGradient
            id="SVGID_00000099632025501996887540000018364847534469516957_"
            x1="264.743"
            x2="301.924"
            y1="310.4"
            y2="310.4"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000099632025501996887540000018364847534469516957_)"
            d="M270.9 605.4c-.3 0-.6-.1-.8-.1-.4-.2-1-.6-1.9-2.6-2.8-6.4-6.4-24.4.6-39.7 7.5-16.6 23.3-23.6 28.3-23.6.7 0 1.2.1 1.6.4 3.8 2.6 5.6 20.6-1.8 38.3-7.1 16.3-21.9 27.3-26 27.3zm26.2-64.4c-4.7 0-19.6 6.7-26.8 22.7-8.2 18-1.3 38.9.5 40.1h.2c3.4 0 17.6-10.4 24.3-26.4 7.1-17 5.4-34.2 2.5-36.2-.1-.2-.3-.2-.7-.2z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M231.2 588.3c12.8 17.7 32.1 19.7 33.9 17.4 1.3-2-.7-23.8-12-40.7-11.4-17-29.1-24.3-31.5-22.1-3.5 2.9-3.3 27.6 9.6 45.4z"
          ></path>
          <linearGradient
            id="SVGID_00000044150253819957930080000015441025290134753982_"
            x1="218.848"
            x2="266.229"
            y1="312.5"
            y2="312.5"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000044150253819957930080000015441025290134753982_)"
            d="M261.9 607.3c-6.2 0-20.8-3.9-31.4-18.5-12.6-17.4-13.7-43.1-9.6-46.5.4-.4 1.1-.6 2-.6 5.4 0 20.7 7.8 30.8 22.8 11.2 16.8 13.6 39.3 12 41.7-.5.8-1.8 1.1-3.8 1.1zM223 543.4c-.7 0-.9.2-.9.2-2.7 2.3-3.2 26.3 9.8 44.3 9.5 13.1 23.1 17.8 30 17.8 1.7 0 2.4-.3 2.5-.4 1-1.9-1.2-23.5-12.1-39.8-9.7-14.5-24.3-22.1-29.3-22.1z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M292.5 533.4c-9.6 15.9-26.7 24.2-29.2 22.6-2-1-5.9-23.9 5-40.9 10.8-16.8 29.5-20.1 31.6-18.2 3 2.8 2.2 20.6-7.4 36.5z"
          ></path>
          <linearGradient
            id="SVGID_00000007422243090600113570000004215588576949586567_"
            x1="260.14"
            x2="302.319"
            y1="264.3"
            y2="264.3"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000007422243090600113570000004215588576949586567_)"
            d="M264.2 557c-.5 0-1-.1-1.3-.3-.4-.2-.9-.8-1.5-2.9-1.5-5.4-3.5-24 6.2-39.1 9.2-14.4 24.3-19.1 30.1-19.1 1.3 0 2.3.2 2.8.7 3.4 3.2 2.6 21.2-7.3 37.5-8.6 14.2-23.8 23.2-29 23.2zm33.5-59.8c-5.5 0-19.8 4.5-28.7 18.3-10.7 16.6-6.8 38.2-5.3 39.7 0 0 .1.1.5.1 4.3 0 19.1-8.5 27.6-22.4 9.5-15.7 10.2-33 7.6-35.5-.1 0-.6-.2-1.7-.2z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M226.9 533.9c10.1 19.5 28.9 24.4 31 22.5 1.6-1.7 2.7-23.7-6.1-42.1-8.9-18.5-25.3-28.5-28.1-26.7-3.7 2.2-7 26.8 3.2 46.3z"
          ></path>
          <linearGradient
            id="SVGID_00000084527801376721251810000016579420094303600556_"
            x1="219.325"
            x2="259.832"
            y1="260.05"
            y2="260.05"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000084527801376721251810000016579420094303600556_)"
            d="M256.3 557.6c-6.3 0-21.5-6.8-30.1-23.3-10-19.2-7.4-44.7-2.8-47.5.3-.2.8-.3 1.3-.3 5.1 0 19.9 10.7 27.9 27.4 8.7 18.4 7.9 40.9 6 43-.6.5-1.3.7-2.3.7zm-31.6-69.4c-.3 0-.4.1-.4.1-3 1.8-6.9 25.5 3.4 45.3 8.9 17.1 24.1 22.4 28.6 22.4.7 0 1-.1 1.1-.2 1-1.4 2.7-22.3-6.3-41.2-7.9-16.4-22.3-26.4-26.4-26.4z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M295.3 489.1c-11.8 14.2-29.8 19.8-32.1 17.8-1.8-1.3-2.4-24.6 10.8-39.6 13.1-15 32.1-15.4 33.9-13.1 2.6 3.2-.9 20.7-12.6 34.9z"
          ></path>
          <linearGradient
            id="SVGID_00000057856013694573762570000018249436852763543478_"
            x1="261.45"
            x2="309.502"
            y1="218.15"
            y2="218.15"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000057856013694573762570000018249436852763543478_)"
            d="M264.9 508.1c-1 0-1.7-.2-2.2-.6-.4-.3-.8-.9-1.1-3.3-.6-5.5.1-24.3 11.8-37.6 9.3-10.6 21.9-14.4 29.9-14.4 1.6 0 4.3.2 5.3 1.3 2.9 3.7-.5 21.4-12.6 36-10.3 12.5-25.5 18.6-31.1 18.6zm38.4-54.1c-7.6 0-19.7 3.6-28.7 13.8-12.7 14.5-12.2 36.8-10.9 38.5 0 0 .2.2 1.1.2 4.4 0 19.2-5.2 29.8-17.9 11.6-14 14.8-31.1 12.6-33.9-.1-.3-1.3-.7-3.9-.7z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M230.4 479.5c7.2 20.9 25.1 28.6 27.5 27 1.8-1.5 6-23 0-42.6-6.1-19.7-20.9-32.1-23.9-30.8-4.1 1.7-11 25.4-3.6 46.4z"
          ></path>
          <linearGradient
            id="SVGID_00000031897041121341746910000000228211821453044383_"
            x1="226.346"
            x2="261.724"
            y1="207.8"
            y2="207.8"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000031897041121341746910000000228211821453044383_)"
            d="M256.9 507.5c-4.9 0-20.7-8.5-27.3-27.8-7.2-20.6-.9-45.4 4-47.4.2-.1.5-.2.9-.2 4.3 0 18.2 12.2 24.1 31.5 6 19.5 1.9 41.7-.3 43.5-.3.3-.8.4-1.4.4zm-22.4-73.6h-.2c-3.3 1.3-10.5 24.1-3.1 45.3 6.5 18.6 21.8 26.6 25.8 26.6.3 0 .4-.1.4-.1 1.6-1.6 5.6-22.5-.3-41.7-5.8-18.2-19.3-30.1-22.6-30.1z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M304.5 445.7c-13.7 12.2-32.3 15-34.3 12.7-1.6-1.6 1.2-24.7 16.4-37.6 15.1-12.8 34-10.2 35.5-7.8 2 3.7-4 20.5-17.6 32.7z"
          ></path>
          <linearGradient
            id="SVGID_00000003817995203522843960000001544833422516069790_"
            x1="268.93"
            x2="323.322"
            y1="173.1"
            y2="173.1"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000003817995203522843960000001544833422516069790_)"
            d="M273.4 460c-2 0-3.2-.3-3.8-1-.2-.2-.7-.8-.6-3.5.3-8.3 5.2-25.2 17.1-35.3 10.7-9 22.5-10 27.1-10 4.1 0 8.7.7 9.7 2.4 2.3 4.1-3.7 21.1-17.8 33.7-11.2 10-25.4 13.7-31.7 13.7zm39.7-48.1c-4.4 0-15.8.9-26 9.6-14.7 12.4-17.4 34.6-16.3 36.4.1.1.8.5 2.6.5 6.1 0 19.7-3.6 30.5-13.2 13.5-12.1 19.2-28.5 17.5-31.6-.3-.6-3.1-1.7-8.3-1.7z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M241.6 426.2c4.1 21.8 20.7 32.2 23.3 31 2-1.2 9.3-21.8 6.2-42.2-3.2-20.5-15.9-35.1-19.1-34.2-4.3 1-14.6 23.5-10.4 45.4z"
          ></path>
          <linearGradient
            id="SVGID_00000155107055927557574100000003561120807532807298_"
            x1="239.83"
            x2="272.654"
            y1="157"
            y2="157"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000155107055927557574100000003561120807532807298_)"
            d="M264.4 458.1c-4.5 0-19.6-10.9-23.6-31.8-4.1-21.5 5.8-45.1 11-46.3.1 0 .3-.1.5-.1 4.2 0 16.5 14.7 19.6 34.9 3.1 20.3-4.2 41.6-6.6 43-.3.2-.6.3-.9.3zm-12.1-76.5h-.1c-3.4.8-14 22.3-9.7 44.4 3.8 20.3 18.8 30.4 21.9 30.4h.1c1.9-1.6 8.7-21.5 5.8-41.3-3.1-19.6-14.9-33.5-18-33.5z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M320 404.2c-15.4 10-34.3 9.8-35.9 7.2-1.4-1.8 4.8-24.3 21.9-34.7 17-10.3 35.4-4.9 36.4-2.2 1.5 4-7.1 19.7-22.4 29.7z"
          ></path>
          <linearGradient
            id="SVGID_00000123425864545176202040000014741352280289094293_"
            x1="283.058"
            x2="343.49"
            y1="129.85"
            y2="129.85"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000123425864545176202040000014741352280289094293_)"
            d="M291 413.8c-2.4 0-6.6-.2-7.6-1.9-.2-.3-.6-.9-.1-3.6 1.5-8.2 9-24.1 22.3-32.2 8.4-5.1 16.7-6.2 22.2-6.2 8.1 0 14.7 2.3 15.5 4.4 1.6 4.4-7 20.3-22.9 30.6-10.1 6.5-21.8 8.9-29.4 8.9zm36.8-42.3c-5.3 0-13.3 1-21.3 5.9C290 387.5 284 409 284.8 411c.2.4 2 1.1 6.2 1.1 7.3 0 18.7-2.3 28.5-8.6 15.2-9.9 23.4-25.2 22.2-28.6-.3-.9-5.7-3.4-13.9-3.4z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M260.6 375.1c.8 22.2 15.7 35.1 18.4 34.3 2.2-.9 12.4-20.2 12.5-40.8 0-20.8-10.3-37.2-13.6-36.8-4.4.3-18.1 21-17.3 43.3z"
          ></path>
          <linearGradient
            id="SVGID_00000066500292318441742640000006168702335470998176_"
            x1="259.775"
            x2="292.37"
            y1="108.55"
            y2="108.55"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000066500292318441742640000006168702335470998176_)"
            d="M278.8 410.2c-3.7 0-18.2-13.2-18.9-35.1-.8-21.9 12.7-43.8 18.1-44.2h.2c.8 0 1.8.5 2.8 1.6 4.8 4.8 11.5 19.1 11.5 36-.1 21-10.3 40.5-13 41.6-.4.1-.6.1-.7.1zm-.7-77.6c-3.6.3-17.5 19.9-16.6 42.5.8 21.4 14.8 33.5 17.3 33.5 2.1-1.3 11.8-20 11.9-40 0-16.2-6.5-30.4-11-34.8-1.1-1.2-1.6-1.2-1.6-1.2z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M341.8 365.4c-16.9 7.5-35.6 4.5-36.7 1.6-1.1-2 8.6-23.3 27.3-30.9 18.6-7.6 36.1.6 36.7 3.5.7 4.1-10.5 18.3-27.3 25.8z"
          ></path>
          <linearGradient
            id="SVGID_00000040549554783758756570000007326418907828958861_"
            x1="304.137"
            x2="370.041"
            y1="89.6"
            y2="89.6"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000040549554783758756570000007326418907828958861_)"
            d="M318.9 371c-6.5 0-13.6-1.2-14.6-3.5-.1-.3-.5-1 .5-3.6 2.8-7.9 12.7-22.5 27.3-28.5 5.2-2.1 10.7-3.2 16.4-3.2 11.7 0 20.9 4.7 21.5 7.2.8 4.6-10.3 19-27.8 26.8-7 3.1-15.3 4.8-23.3 4.8zm29.5-37.2c-5.4 0-10.7 1-15.7 3.1-18 7.3-27.4 27.8-26.9 29.8.3.7 4.7 2.6 13.1 2.6 7.8 0 15.8-1.6 22.5-4.6 16.8-7.5 27.5-21.4 26.8-24.9-.2-1.3-8-6-19.8-6z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M287.5 327.5c-2.7 22.1 10.1 37.2 12.8 36.8 2.3-.5 15.4-18.1 18.9-38.5 3.4-20.6-4.1-38.4-7.4-38.5-4.5-.4-21.6 17.9-24.3 40.2z"
          ></path>
          <linearGradient
            id="SVGID_00000097490835517105279540000013428003647604396477_"
            x1="286.227"
            x2="320.986"
            y1="63.75"
            y2="63.75"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000097490835517105279540000013428003647604396477_)"
            d="M300.2 365.1c-1.4 0-3.3-1.9-4.3-3-5.5-6.2-11.2-19.1-9.3-34.7 2.6-21.5 19.4-41 25.1-41h.2c.7 0 1.5.5 2.4 1.6 3.5 4.3 8.8 19.8 5.8 37.9-3.6 20.8-16.8 38.5-19.6 39.2h-.3zm0-1.3v.5-.5zm11.5-75.7c-3.8 0-20.7 17.3-23.4 39.5-1.9 15.1 3.6 27.5 8.9 33.4 1.7 1.9 2.7 2.4 3 2.4 2.3-1 14.9-17.9 18.3-37.8 2.9-17.6-2.1-32.5-5.5-36.6-.6-.7-1-.9-1.3-.9z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M369.9 330.5c-18.2 4.8-36.2-1.1-37-4.1-.8-2.2 12.4-21.8 32.6-26.4 20-4.7 36.2 6.2 36.3 9.1.1 4.1-13.8 16.5-31.9 21.4z"
          ></path>
          <linearGradient
            id="SVGID_00000124119368625205324290000010562446977328075693_"
            x1="332.144"
            x2="402.8"
            y1="53.55"
            y2="53.55"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000124119368625205324290000010562446977328075693_)"
            d="M355.5 333.1c-12 0-22.5-3.5-23.3-6.5-.1-.4-.2-1.3 1-3.3 2.7-5 14.4-20 32.3-24.1 3.3-.8 6.7-1.2 10.1-1.2 15.2 0 27.1 7.8 27.2 11.1 0 5.1-15.2 17.6-32.6 22.2-4.7 1.2-9.6 1.8-14.7 1.8zm20-33.4c-3.3 0-6.6.4-9.8 1.1-19.8 4.6-32.2 23.2-32 25.4.3 1.3 8.8 5.3 21.7 5.3 4.9 0 9.7-.6 14.2-1.8 18.1-4.9 31.4-16.9 31.4-20.6 0-1.8-10.5-9.4-25.5-9.4z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M397.5 282.6c-17.2 12.1-37.5 15.2-39.6 13.2-1.6-1.4 2.8-23.5 22.1-37.2 19.3-13.7 42.7-12 43.9-9.4 1.7 3.7-9.3 21.2-26.4 33.4z"
          ></path>
          <linearGradient
            id="SVGID_00000175317074319211221690000010029781717337328570_"
            x1="356.711"
            x2="424.856"
            y1="9.85"
            y2="9.85"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000175317074319211221690000010029781717337328570_)"
            d="M360.6 297.2c-2.3 0-3-.4-3.4-.8-.5-.4-.6-1.2-.6-2.5.3-6.7 6.3-24.3 22.8-36 14.8-10.5 30.9-11.4 35.4-11.4 2 0 8.8.2 9.7 2.3 2.1 4.3-9.5 22.1-26.6 34.4-13.6 9.7-30 14-37.3 14zm-2.1-2c.2.1.7.3 2.2.3 7.1 0 23-4.2 36.4-13.6 17.3-12.3 27.5-29.4 26.1-32.3-.3-.5-3.1-1.3-8.2-1.3-4.4 0-20 .8-34.5 11.1-18.2 12.8-22.9 33.5-22 35.8z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M322.1 284.4c-6.5 21.5 3.8 38.4 6.6 38.4 2.3-.2 18.4-15.5 25.5-35.2 7.1-19.8 2.8-38.7-.6-39.3-4.5-1-25.1 14.5-31.5 36.1z"
          ></path>
          <linearGradient
            id="SVGID_00000129884629374002066820000017557531728530747277_"
            x1="319.132"
            x2="358.89"
            y1="23.6"
            y2="23.6"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000129884629374002066820000017557531728530747277_)"
            d="M328.7 323.7c-1 0-2.1-.9-3.3-2.6-3.8-5.1-9.5-19.4-4.2-36.9 6.2-20.8 25.8-36.7 31.9-36.7.2 0 .5 0 .7.1.7.1 1.5.8 2.1 1.9 2.8 4.8 5.3 21-.9 38.5-7.2 20-23.4 35.5-26.3 35.7zm24.5-74.5c-4.7 0-24.1 14.7-30.3 35.5-4.8 16-.1 29.4 3.4 34.8 1.3 1.9 2.1 2.5 2.4 2.6 2.4-.6 17.8-15.4 24.8-34.6 6.1-17 3.7-32.5 1-37.1-.6-1-1-1.1-1-1.1-.1-.1-.2-.1-.3-.1z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M411.3 802.8c-.4-.2-1.2.5-1.9 1.6s-.9 2.2-.5 2.4c37.7 22.1 82.5 37.3 134.3 43 .2-1.5.3-3 .5-4.6-51.2-5.7-95.3-20.6-132.4-42.4z"
          ></path>
          <linearGradient
            id="SVGID_00000103960910905364025290000008744233907876170679_"
            x1="407.765"
            x2="544.5"
            y1="564.3"
            y2="564.3"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000103960910905364025290000008744233907876170679_)"
            d="M543.8 850.7l-.8-.1c-49.9-5.5-95.2-20-134.6-43.1-.2-.1-.4-.3-.6-.8-.2-1 .5-2.4.8-2.8.3-.5 1.3-2 2.5-2 .2 0 .4.1.6.2 38.7 22.6 83.1 36.9 132 42.3l.8.1-.7 6.2zm-134.3-44.5c39 22.8 83.7 37.1 132.9 42.7l.3-2.9c-48.8-5.5-93-19.7-131.7-42.3-.2.1-.6.5-1 1.2-.3.5-.5 1-.5 1.3z"
          ></path>
        </g>
        <g>
          <path
            fill="#020203"
            d="M696.6 764.7c-7.9 17.6-5.2 36.4-2.2 37.5 2.2 1 24.7-9.8 32.2-29.1 7.6-19.1-1.2-36.5-4-37-4.1-.7-18.1 11.1-26 28.6z"
          ></path>
          <linearGradient
            id="SVGID_00000127755328599118457900000006174593117181902219_"
            x1="690.563"
            x2="730.408"
            y1="507.15"
            y2="507.15"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000127755328599118457900000006174593117181902219_)"
            d="M694.8 803.1c-.3 0-.5 0-.8-.2-.6-.2-1.2-1-1.8-2.2-2.2-5.1-3.4-21 3.5-36.4 7.5-16.6 21.2-29.1 26.5-29.1h.5c1.3.3 2.6 2.2 3.5 3.7 3.2 5.8 7 19.6 1.1 34.4-7.2 18.6-28.2 29.8-32.5 29.8zm27.5-66.3c-3.7 0-17 10.6-25 28.2-6.7 14.9-5.6 30.2-3.5 35.1.5 1.2.9 1.3.9 1.3h.1c3.1 0 23.9-10.3 31-28.7 5.2-13.1 2.7-25.9-.9-32.8-1.2-2.2-2.1-3-2.4-3.1-.1.1-.1 0-.2 0z"
          ></path>
          <path
            fill="#020203"
            d="M735.5 818.3c-22.9 3.7-38.8-8.6-38.2-11.5.6-2.3 19.3-16.6 40-20.9 20.9-4.3 38.8 2.9 39 6.2.3 4.6-17.8 22.5-40.8 26.2z"
          ></path>
          <linearGradient
            id="SVGID_00000014635683411421309530000013429899896239359876_"
            x1="696.385"
            x2="777.013"
            y1="539.85"
            y2="539.85"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000014635683411421309530000013429899896239359876_)"
            d="M727 819.9c-15.1 0-26.1-6.5-29.5-10.6-.8-1-1.2-1.9-1.1-2.6.8-2.9 19.9-17.2 40.6-21.6 4.3-.9 8.8-1.3 13.3-1.3 13.9 0 26.5 4.7 26.7 8.3.3 2.8-4.7 8.7-11.9 14.1-5.2 3.9-15.9 10.8-29.5 12.9-2.9.5-5.8.8-8.6.8zM698.1 807c0 .1.1.6 1.1 1.6 3.6 3.8 14 9.5 27.8 9.5 2.8 0 5.6-.2 8.4-.7 23-3.7 40.4-21.6 40-25.2-.1-1.8-10.1-6.8-25-6.8-4.4 0-8.7.4-13 1.3-20.1 4.3-38.3 18-39.3 20.3z"
          ></path>
          <path
            fill="#020203"
            d="M731.8 735c-4.4 18.4 1.7 36.5 4.7 37.2 2.2.7 21.8-13.3 25.7-33.4 4-20-7.4-35.7-10.2-35.8-4.2-.1-15.8 13.6-20.2 32z"
          ></path>
          <linearGradient
            id="SVGID_00000160885511461858402810000017469720544353835916_"
            x1="729.366"
            x2="763.826"
            y1="475.55"
            y2="475.55"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000160885511461858402810000017469720544353835916_)"
            d="M736.7 773h-.4c-.7-.2-1.4-.8-2.1-1.9-3-4.7-7-20.2-3.2-36.3 4.3-17.7 15.9-32.7 21-32.7 1.3 0 2.9 1.7 3.9 3 4.1 5.2 10.2 18.2 7.1 33.7-3.9 20-23.1 34.2-26.3 34.2zm15.2-69.3c-3.5 0-14.9 13.3-19.3 31.4-3.7 15.6.1 30.5 3 35 .7 1.1 1.1 1.2 1.1 1.2 2.3-.1 20.9-13.3 24.7-32.8 2.7-13.8-1.9-25.9-6.6-32.1-1.6-2-2.6-2.7-2.9-2.7z"
          ></path>
          <path
            fill="#020203"
            d="M778.8 781.8c-21.3 7.1-38.7-2.7-38.7-5.5.2-2.4 15.4-19.2 34.6-26.5 19.4-7.3 38.1-3.1 38.8.2 1.2 4.3-13.3 24.7-34.7 31.8z"
          ></path>
          <linearGradient
            id="SVGID_00000074418861522173821740000013734427466543358858_"
            x1="739.2"
            x2="814.377"
            y1="503.05"
            y2="503.05"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000074418861522173821740000013734427466543358858_)"
            d="M763.3 785.2c-13.6 0-24.1-5.9-24.1-8.9.2-2.9 15.9-19.9 35.2-27.3 8.9-3.4 17.1-4.1 22.4-4.1 9.2 0 16.9 2.2 17.6 4.9 1.4 5.3-14.4 25.9-35.3 32.8-5.2 1.7-10.5 2.6-15.8 2.6zm33.4-38.7c-5.1 0-13.1.7-21.8 4-18.7 7.2-33.7 23.6-34.1 25.8.2 1.4 8.9 7.2 22.4 7.2 5.1 0 10.2-.8 15.2-2.5 21.5-7.1 35.2-27.3 34.2-30.8-.2-1.3-6.1-3.7-15.9-3.7z"
          ></path>
          <path
            fill="#020203"
            d="M760.6 700.4c-1.2 18.8 7.9 35.7 10.9 35.8 2.3.3 18.8-16.4 19.3-36.8.6-20.2-13-34-15.8-33.7-4 .7-13.2 16-14.4 34.7z"
          ></path>
          <linearGradient
            id="SVGID_00000034800892757794479930000006366627970336481435_"
            x1="759.697"
            x2="791.711"
            y1="439.05"
            y2="439.05"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000034800892757794479930000006366627970336481435_)"
            d="M771.6 737.1c-.8 0-1.6-.5-2.5-1.5-3.8-4.2-10.3-18.8-9.3-35.2 1.2-18.1 10.1-34.6 15.1-35.4h.2c1.6 0 4.1 2.3 5 3.3 5.8 6 11.9 17.4 11.6 31.2-.5 19.8-16.6 37.6-20.1 37.6zm3.5-70.5c-3.4.5-12.5 15.3-13.7 33.9-1 15.9 5.3 29.9 8.9 33.9.7.8 1.1 1 1.3 1 2.2-.4 17.9-16.4 18.4-36 .5-17.2-9.1-28-11.1-30-1.9-2-3.3-2.8-3.8-2.8z"
          ></path>
          <path
            fill="#020203"
            d="M814.3 739.4c-19.5 10.2-38 3.2-38.5.4-.3-2.4 11.6-21.2 29.2-31.3 17.7-10.2 36.7-8.8 38-5.7 1.8 4-9.1 26.3-28.7 36.6z"
          ></path>
          <linearGradient
            id="SVGID_00000074437586675357204280000010189757950771142556_"
            x1="774.995"
            x2="843.957"
            y1="460.65"
            y2="460.65"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000074437586675357204280000010189757950771142556_)"
            d="M792.8 745.6c-9.3 0-17.3-3.1-17.8-5.6-.3-2.9 12-22.1 29.6-32.2 12.7-7.3 24.6-8.1 29.1-8.1 2.1 0 9 .2 10 2.8 2.2 4.9-9.9 27.7-29.1 37.7-6.8 3.5-14.4 5.4-21.8 5.4zm40.8-44.3c-4.4 0-15.9.8-28.3 7.9-17 9.9-28.8 28.3-28.7 30.5.3 1 6.5 4.2 16.2 4.2 7.2 0 14.5-1.8 21.1-5.3 19.8-10.3 29.8-32.2 28.3-35.5-.3-.6-2.7-1.8-8.6-1.8z"
          ></path>
          <path
            fill="#020203"
            d="M783.1 662.1c1.9 18.7 13.5 33.9 16.5 33.6 2.3 0 15.7-19 13.1-39.2-2.6-20-18.1-31.5-20.8-30.7-3.9 1.2-10.6 17.7-8.8 36.3z"
          ></path>
          <linearGradient
            id="SVGID_00000041266006686785294130000008105326929178860190_"
            x1="781.976"
            x2="813.847"
            y1="398.7"
            y2="398.7"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000041266006686785294130000008105326929178860190_)"
            d="M799.5 696.5c-3.8 0-15.4-15.6-17.2-34.3-1.9-19.2 5-35.9 9.4-37.2.2 0 .4-.1.5-.1 3.7 0 18.7 11.5 21.3 31.5 2.2 16.7-6.6 32.9-11.2 38.2-1.5 1.7-2.2 1.9-2.8 1.9.1 0 .1 0 0 0zm-7.3-70c-3.4 1-10 17-8.2 35.5s13.1 32.8 15.6 32.8h.1c2-.6 14.8-18.5 12.2-38.2-2.6-19.6-17.1-30.1-19.7-30.1z"
          ></path>
          <path
            fill="#020203"
            d="M842 692.2c-17.5 13.1-36.6 9-37.6 6.3-.7-2.3 7.9-22.6 23.6-35.3 15.8-12.7 34.8-14.3 36.5-11.5 2.4 3.8-4.9 27.4-22.5 40.5z"
          ></path>
          <linearGradient
            id="SVGID_00000027573545046540320590000006469980903001366462_"
            x1="803.451"
            x2="865.663"
            y1="413.85"
            y2="413.85"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000027573545046540320590000006469980903001366462_)"
            d="M815.4 702.1c-6.1 0-11.2-1.4-11.9-3.3-.8-2.8 8.2-23.6 23.8-36.3 12.6-10.2 26.3-12.9 32.3-12.9 2.9 0 4.8.5 5.4 1.6 2.9 4.5-5.5 28.8-22.7 41.6-10.6 8.1-21.4 9.3-26.9 9.3zm44.3-50.8c-7.6 0-20.6 3.9-31.3 12.5-15.2 12.3-23.7 32.2-23.3 34.5.3.5 3.8 2.2 10.3 2.2 5.3 0 15.6-1.2 26-8.9 17.8-13.2 24.2-36.4 22.3-39.4-.1-.3-1.1-.9-4-.9z"
          ></path>
          <path
            fill="#020203"
            d="M799.3 620.8c4.7 18.1 18.5 31.3 21.4 30.6 2.2-.4 12.5-21.1 6.9-40.6-5.5-19.4-22.5-28.3-25.1-27.1-3.6 1.7-7.8 19-3.2 37.1z"
          ></path>
          <linearGradient
            id="SVGID_00000141434773337410534010000001194448303373559441_"
            x1="796.453"
            x2="830.108"
            y1="355.4"
            y2="355.4"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000141434773337410534010000001194448303373559441_)"
            d="M820.5 652.2c-4 0-17.4-13.5-21.9-31.2-4.8-18.7-.4-36.2 3.7-38.2.3-.1.6-.2 1-.2 4.5 0 20.1 9.6 25.3 27.8 4.7 16.2-1.5 33.6-5.3 39.4-1.2 1.8-1.8 2.2-2.3 2.3-.2.1-.4.1-.5.1zm-17.3-67.9h-.2c-3.2 1.6-7.3 18.3-2.8 36.2 4.4 17.2 17.4 30 20.3 30h.1c1.9-.9 11.7-20.5 6.2-39.6-5.1-18-20.5-26.6-23.6-26.6z"
          ></path>
          <g>
            <path
              fill="#020203"
              d="M861.9 641.5c-15.3 15.6-34.7 14.5-36.1 12-1-2.1 4.3-23.5 17.9-38.5 13.7-15 32.2-19.5 34.4-16.9 2.9 3.3-.9 27.7-16.2 43.4z"
            ></path>
            <linearGradient
              id="SVGID_00000097467348153387111210000005873715398274522772_"
              x1="824.842"
              x2="879.701"
              y1="364.2"
              y2="364.2"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000097467348153387111210000005873715398274522772_)"
              d="M832 655.8c-1.4 0-6-.1-7-1.9-1.2-2.7 4.4-24.5 18-39.4 11.2-12.2 26-17.9 32.5-17.9 1.5 0 2.6.3 3.1 1 3.5 4-1.2 29.2-16.2 44.5-12.4 12.7-26.4 13.7-30.4 13.7zm43.5-57.6c-6.2 0-20.4 5.5-31.2 17.4-13.1 14.5-18.5 35.4-17.7 37.5.2.3 1.9 1 5.5 1 7.9 0 19.7-3.5 29.2-13.2 15.5-15.8 18.5-39.6 16.1-42.3-.1-.2-.7-.4-1.9-.4z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M809.2 577.6c7.3 17.2 22.9 28.1 25.6 26.9 2.1-.7 9.2-22.8.9-41.2-8.3-18.3-26.3-24.5-28.7-22.9-3.3 2.3-5 20 2.2 37.2z"
            ></path>
            <linearGradient
              id="SVGID_00000007386150206947306980000012177917606893382034_"
              x1="803.287"
              x2="840.471"
              y1="310.3"
              y2="310.3"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000007386150206947306980000012177917606893382034_)"
              d="M834.3 605.4c-4.1 0-18.9-11-25.9-27.5-7.4-17.7-5.6-35.6-1.9-38.3.4-.3.9-.4 1.6-.4 5 0 20.8 7 28.3 23.6 6.9 15.3 3.4 33.4.6 39.7-.9 2-1.5 2.4-1.9 2.6-.2.2-.5.3-.8.3zM808.1 541c-.5 0-.7.1-.7.1-2.9 2-4.6 19.3 2.5 36.2 6.8 16.1 21 26.4 24.3 26.4H834.5c1.7-1.2 8.6-22 .4-40.1-7.1-15.9-22-22.6-26.8-22.6z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M874 588.3c-12.8 17.7-32.1 19.7-33.9 17.4-1.3-2 .7-23.8 12-40.7 11.4-17 29.1-24.3 31.5-22.1 3.5 2.9 3.3 27.6-9.6 45.4z"
            ></path>
            <linearGradient
              id="SVGID_00000061470551468980428790000017573503365972941494_"
              x1="838.992"
              x2="886.395"
              y1="312.5"
              y2="312.5"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000061470551468980428790000017573503365972941494_)"
              d="M843.3 607.3c-2 0-3.3-.4-3.8-1.1-1.6-2.4.8-24.9 12-41.7 10.1-15 25.4-22.8 30.8-22.8.9 0 1.6.2 2 .6 4.1 3.4 3.1 29-9.6 46.5-10.6 14.7-25.2 18.5-31.4 18.5zm38.9-63.9c-5.1 0-19.6 7.6-29.4 22.1-10.9 16.3-13.1 37.8-12 39.8.1.1.7.4 2.5.4 6.9 0 20.6-4.7 30-17.8 13.1-18 12.6-42 9.8-44.3 0-.1-.2-.2-.9-.2z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M812.7 533.4c9.6 15.9 26.7 24.2 29.2 22.6 2-1 5.9-23.9-5-40.9-10.8-16.8-29.5-20.1-31.6-18.2-3 2.8-2.1 20.6 7.4 36.5z"
            ></path>
            <linearGradient
              id="SVGID_00000085960016134345276140000018304820683859298233_"
              x1="802.926"
              x2="845.06"
              y1="264.3"
              y2="264.3"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000085960016134345276140000018304820683859298233_)"
              d="M841 557c-5.1 0-20.4-9-29-23.2-9.9-16.3-10.6-34.4-7.3-37.5.5-.5 1.4-.7 2.8-.7 5.8 0 20.9 4.7 30.1 19.1 9.7 15.1 7.7 33.8 6.2 39.1-.6 2.1-1.1 2.7-1.5 2.9-.3.2-.8.3-1.3.3zm-33.5-59.8c-1.1 0-1.6.2-1.7.3-2.6 2.5-1.9 19.8 7.6 35.4 8.4 13.9 23.3 22.4 27.6 22.4.3 0 .4-.1.4-.1h.1c1.5-1.4 5.4-23-5.3-39.7-8.9-13.8-23.2-18.3-28.7-18.3z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M878.3 533.9c-10.1 19.5-28.9 24.4-31 22.5-1.6-1.7-2.7-23.7 6.1-42.1 8.9-18.5 25.3-28.5 28.1-26.7 3.7 2.2 7 26.8-3.2 46.3z"
            ></path>
            <linearGradient
              id="SVGID_00000149365719695398812260000008067771737894915730_"
              x1="845.446"
              x2="885.938"
              y1="260.05"
              y2="260.05"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000149365719695398812260000008067771737894915730_)"
              d="M849 557.6c-1 0-1.8-.2-2.2-.6-2-2.2-2.8-24.7 5.9-43.1 8-16.7 22.8-27.4 27.9-27.4.5 0 1 .1 1.3.3 4.5 2.7 7.2 28.3-2.9 47.5-8.5 16.5-23.8 23.3-30 23.3zm-1.1-1.8s.3.1 1 .1c4.5 0 19.7-5.3 28.6-22.4 10.3-19.8 6.4-43.5 3.4-45.3-.1 0-.2-.1-.5-.1-4.2 0-18.5 10-26.4 26.4-8.8 18.9-7.2 39.9-6.1 41.3z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M809.9 489.1c11.8 14.2 29.8 19.8 32.1 17.8 1.8-1.3 2.4-24.6-10.8-39.6-13.1-15-32.1-15.4-33.9-13.1-2.5 3.2.9 20.7 12.6 34.9z"
            ></path>
            <linearGradient
              id="SVGID_00000181797689352029587150000001442644486491921549_"
              x1="795.666"
              x2="843.744"
              y1="218.2"
              y2="218.2"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000181797689352029587150000001442644486491921549_)"
              d="M840.3 508.1c-5.6 0-20.9-6.2-31.1-18.5-12.1-14.6-15.4-32.4-12.6-36 .9-1.1 3.7-1.3 5.3-1.3 8 0 20.6 3.8 29.9 14.4 11.6 13.3 12.4 32.1 11.8 37.6-.3 2.3-.7 3-1.1 3.3-.5.4-1.2.5-2.2.5zM801.9 454c-2.6 0-3.8.5-4 .7-2.2 2.9 1 19.9 12.6 33.9 10.6 12.8 25.4 17.9 29.8 17.9.9 0 1.1-.2 1.1-.2l.1-.1c1.3-1.6 1.8-23.9-10.9-38.4-8.9-10.2-21-13.8-28.7-13.8z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M874.9 479.5c-7.2 20.9-25.1 28.6-27.5 27-1.8-1.5-6-23 0-42.6 6.1-19.7 20.9-32.1 23.9-30.8 4.1 1.7 10.9 25.4 3.6 46.4z"
            ></path>
            <linearGradient
              id="SVGID_00000057830187198514063280000009163908787854966207_"
              x1="843.449"
              x2="878.858"
              y1="207.8"
              y2="207.8"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000057830187198514063280000009163908787854966207_)"
              d="M848.3 507.5c-.6 0-1-.1-1.4-.4-2.3-1.8-6.3-24-.3-43.5 6-19.3 19.9-31.5 24.2-31.5.3 0 .6.1.9.2 4.9 2 11.2 26.9 4 47.4-6.7 19.3-22.5 27.8-27.4 27.8zm-.4-1.7h.4c4 0 19.3-8 25.8-26.6 7.4-21.2.2-44-3.1-45.3h-.2c-3.4 0-16.8 11.9-22.6 30.3-5.9 19.1-1.9 39.9-.3 41.6z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M800.8 445.7c13.7 12.2 32.3 15 34.3 12.7 1.6-1.6-1.2-24.7-16.4-37.6-15.1-12.8-34-10.2-35.5-7.8-2.1 3.7 3.9 20.5 17.6 32.7z"
            ></path>
            <linearGradient
              id="SVGID_00000016762871607649143570000015064708242355647892_"
              x1="781.952"
              x2="836.313"
              y1="173.15"
              y2="173.15"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000016762871607649143570000015064708242355647892_)"
              d="M831.8 460c-6.3 0-20.5-3.7-31.6-13.6-14.1-12.6-20-29.6-17.8-33.7 1-1.7 5.6-2.4 9.7-2.4 4.6 0 16.4 1 27.1 10 11.9 10.1 16.8 27 17.1 35.3.1 2.7-.4 3.3-.6 3.5-.6.5-1.9.9-3.9.9zm-39.7-48.1c-5.2 0-8 1.1-8.3 1.6-1.8 3.2 4 19.5 17.5 31.6 10.8 9.6 24.4 13.2 30.5 13.2 1.8 0 2.5-.3 2.6-.5l.1-.1c1-1.8-1.7-23.9-16.4-36.3-10.2-8.6-21.6-9.5-26-9.5z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M863.6 426.2c-4.1 21.8-20.7 32.2-23.3 31-2-1.2-9.2-21.8-6.2-42.2 3.2-20.5 15.9-35.1 19.1-34.2 4.3 1 14.6 23.5 10.4 45.4z"
            ></path>
            <linearGradient
              id="SVGID_00000060742216163847286010000005608988957368224689_"
              x1="832.638"
              x2="865.463"
              y1="157"
              y2="157"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000060742216163847286010000005608988957368224689_)"
              d="M840.9 458.1c-.3 0-.6-.1-.9-.2-2.5-1.4-9.7-22.8-6.6-43.1 3.1-20.2 15.4-34.9 19.6-34.9.2 0 .4 0 .5.1 5.1 1.2 15.1 24.9 11 46.3-4 20.9-19.1 31.8-23.6 31.8zm-.2-1.7c3.2 0 18.2-10.1 22-30.4 4.3-22.1-6.3-43.6-9.7-44.4h-.1c-3.1 0-14.9 13.9-18 33.5-2.9 19.8 3.9 39.7 5.8 41.3z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M785.3 404.2c15.4 10 34.3 9.8 35.9 7.2 1.4-1.8-4.8-24.3-21.9-34.7-17-10.3-35.4-4.9-36.5-2.2-1.5 4 7.1 19.7 22.5 29.7z"
            ></path>
            <linearGradient
              id="SVGID_00000056388541699326589260000012827803120428977829_"
              x1="761.73"
              x2="822.141"
              y1="129.85"
              y2="129.85"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000056388541699326589260000012827803120428977829_)"
              d="M814.2 413.8c-7.6 0-19.3-2.3-29.4-8.9-15.9-10.3-24.4-26.3-22.9-30.6.8-2.1 7.4-4.4 15.5-4.4 5.5 0 13.8 1.1 22.2 6.2 13.3 8.1 20.7 24 22.3 32.2.5 2.7.1 3.4-.1 3.7-1 1.5-5.2 1.8-7.6 1.8zm-36.8-42.3c-8.3 0-13.6 2.5-13.9 3.3-1.2 3.4 7 18.7 22.2 28.6 9.8 6.3 21.1 8.6 28.5 8.6 4.2 0 6-.7 6.2-1.1l.1-.1c.8-1.9-5.2-23.4-21.7-33.4-8.1-4.8-16.1-5.9-21.4-5.9z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M844.6 375.1c-.8 22.2-15.7 35.1-18.4 34.3-2.2-.9-12.4-20.2-12.5-40.8 0-20.8 10.3-37.2 13.6-36.8 4.4.3 18.1 21 17.3 43.3z"
            ></path>
            <linearGradient
              id="SVGID_00000034812196349317745000000005154953601190688185_"
              x1="812.852"
              x2="845.448"
              y1="108.544"
              y2="108.544"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000034812196349317745000000005154953601190688185_)"
              d="M826.5 410.2c-.2 0-.4 0-.5-.1-2.7-1.1-13-20.6-13.1-41.6 0-16.9 6.7-31.2 11.5-36 1.2-1.2 2.2-1.7 3.1-1.6 5.3.4 18.9 22.3 18 44.2-.9 22-15.4 35.1-19 35.1zm0-1.6c2.5 0 16.5-12.1 17.3-33.5.9-22.6-13-42.2-16.5-42.5-.1 0-.6 0-1.7 1.1-4.4 4.4-11 18.6-11 34.8 0 20.1 9.7 38.7 11.9 40.1z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M763.5 365.4c16.9 7.5 35.6 4.5 36.7 1.6 1.1-2-8.6-23.3-27.3-30.9-18.6-7.6-36.1.6-36.7 3.5-.8 4.1 10.4 18.3 27.3 25.8z"
            ></path>
            <linearGradient
              id="SVGID_00000049192089362489658600000004579576930514372250_"
              x1="735.26"
              x2="801.129"
              y1="89.55"
              y2="89.55"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000049192089362489658600000004579576930514372250_)"
              d="M786.3 371c-8 0-16.3-1.7-23.2-4.8-17.5-7.8-28.6-22.2-27.8-26.8.5-2.6 9.8-7.3 21.5-7.3 5.7 0 11.2 1.1 16.4 3.2 14.6 5.9 24.5 20.6 27.3 28.5.9 2.6.6 3.3.5 3.6-1.1 2.4-8.2 3.6-14.7 3.6zm-29.5-37.2c-11.7 0-19.6 4.7-19.8 5.9-.7 3.5 10.1 17.4 26.8 24.9 6.7 3 14.7 4.6 22.5 4.6 8.5 0 12.8-1.8 13.1-2.6v-.1c.5-2-8.9-22.4-26.9-29.8-5-1.8-10.3-2.9-15.7-2.9z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M817.8 327.5c2.7 22.1-10.1 37.2-12.8 36.8-2.3-.5-15.4-18.1-18.9-38.5-3.4-20.6 4.1-38.4 7.4-38.5 4.4-.4 21.6 17.9 24.3 40.2z"
            ></path>
            <linearGradient
              id="SVGID_00000090979782916200036840000009127567486573780640_"
              x1="784.238"
              x2="818.969"
              y1="63.75"
              y2="63.75"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000090979782916200036840000009127567486573780640_)"
              d="M805 365.1h-.2c-2.9-.6-16.1-18.4-19.6-39.2-3-18.1 2.3-33.6 5.8-37.9.8-1 1.6-1.5 2.4-1.6h.2c5.6 0 22.5 19.5 25.1 41 2 15.7-3.8 28.5-9.3 34.7-1.1 1.1-3 3-4.4 3zm0-1.7v.8-.8zm-11.5-75.3c-.2 0-.7.2-1.3 1-3.4 4.1-8.4 19-5.5 36.6 3.4 19.9 16 36.8 18.3 37.8.3 0 1.3-.5 3-2.4 5.3-6 10.8-18.3 8.9-33.4-2.7-22.4-19.6-39.6-23.4-39.6z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M735.3 330.5c18.2 4.8 36.2-1.1 37-4.1.8-2.2-12.4-21.8-32.6-26.4-20-4.7-36.2 6.2-36.3 9.1-.1 4.1 13.8 16.5 31.9 21.4z"
            ></path>
            <linearGradient
              id="SVGID_00000127040771162995662470000004184768302605417400_"
              x1="702.5"
              x2="773.141"
              y1="53.5"
              y2="53.5"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000127040771162995662470000004184768302605417400_)"
              d="M749.8 333.1c-5.1 0-10-.6-14.7-1.9-17.4-4.7-32.6-17.1-32.6-22.2.1-3.2 12-11.1 27.2-11.1 3.4 0 6.8.4 10.1 1.2 17.8 4.1 29.5 19.2 32.3 24.1 1.1 2.1 1.1 2.9 1 3.3-.8 3.1-11.4 6.6-23.3 6.6zm-20.1-33.4c-15 0-25.4 7.6-25.6 9.4 0 3.6 13.2 15.7 31.4 20.5 4.5 1.2 9.3 1.8 14.2 1.8 13 0 21.4-4 21.7-5.3v-.1c.1-2.1-12.2-20.8-32-25.3-3.1-.7-6.4-1-9.7-1z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M707.7 282.6c17.2 12.1 37.5 15.2 39.6 13.2 1.6-1.4-2.8-23.5-22.1-37.2-19.3-13.7-42.7-12-43.9-9.4-1.7 3.7 9.4 21.2 26.4 33.4z"
            ></path>
            <linearGradient
              id="SVGID_00000169519353637643378800000012524895113830371484_"
              x1="680.374"
              x2="748.546"
              y1="9.9"
              y2="9.9"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000169519353637643378800000012524895113830371484_)"
              d="M744.6 297.2c-7.3 0-23.7-4.3-37.3-13.9-17.2-12.3-28.7-30.1-26.6-34.4.9-2.1 7.6-2.3 9.7-2.3 4.6 0 20.6.8 35.4 11.4 16.5 11.7 22.5 29.3 22.8 36 .1 1.3-.1 2.1-.6 2.5-.4.3-1.1.7-3.4.7zm-54.3-48.9c-5.1 0-7.9.9-8.2 1.3-1.4 2.9 8.8 20 26.1 32.3 13.3 9.4 29.3 13.6 36.4 13.6 1.5 0 2-.2 2.2-.3.9-2.3-3.8-23-22-35.9-14.5-10.2-30.1-11-34.5-11z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M783.1 284.4c6.5 21.5-3.8 38.4-6.6 38.4-2.3-.2-18.4-15.5-25.5-35.2-7.1-19.8-2.8-38.7.6-39.3 4.5-1 25.1 14.5 31.5 36.1z"
            ></path>
            <linearGradient
              id="SVGID_00000007389391331011237310000015386856594134657423_"
              x1="746.349"
              x2="786.105"
              y1="23.6"
              y2="23.6"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000007389391331011237310000015386856594134657423_)"
              d="M776.5 323.7c-2.9-.2-19-15.7-26.3-35.7-6.2-17.5-3.7-33.7-.9-38.5.7-1.1 1.4-1.8 2.2-1.9.2 0 .4-.1.6-.1 6.1 0 25.6 15.9 31.9 36.7 5.3 17.5-.4 31.8-4.2 36.9-1.3 1.7-2.4 2.6-3.3 2.6zm-24.4-74.5h-.3c-.1 0-.5.1-1.1 1.1-2.6 4.6-5 20.1 1 37.1 7 19.2 22.3 34 24.8 34.6.3-.1 1.1-.6 2.4-2.6 3.5-5.4 8.3-18.8 3.4-34.8-6.2-20.7-25.5-35.4-30.2-35.4z"
            ></path>
          </g>
          <g>
            <path
              fill="#020203"
              d="M694 802.8c.4-.2 1.2.5 1.9 1.6s.9 2.2.5 2.4c-37.7 22.1-82.5 37.3-134.3 43-.2-1.5-.3-3-.5-4.6 51.1-5.7 95.2-20.6 132.4-42.4z"
            ></path>
            <linearGradient
              id="SVGID_00000112599801802803127560000010430297619542293671_"
              x1="560.7"
              x2="697.432"
              y1="564.3"
              y2="564.3"
              gradientTransform="translate(0 262)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#EBB794"></stop>
              <stop offset="0.472" stopColor="#682B24"></stop>
              <stop offset="0.609" stopColor="#EBB794"></stop>
              <stop offset="0.793" stopColor="#EBB794"></stop>
              <stop offset="0.957" stopColor="#C87B52"></stop>
              <stop offset="1" stopColor="#BF6C43"></stop>
            </linearGradient>
            <path
              fill="url(#SVGID_00000112599801802803127560000010430297619542293671_)"
              d="M561.4 850.7l-.7-6.2.8-.1c48.9-5.4 93.4-19.6 132-42.3.2-.1.4-.2.6-.2 1.1 0 2.2 1.5 2.5 2 .2.4 1 1.8.8 2.8-.1.4-.4.7-.6.8-39.4 23.1-84.7 37.6-134.6 43.1l-.8.1zm1.1-4.8l.3 2.9c49.2-5.5 93.9-19.9 132.9-42.6 0-.2-.2-.7-.6-1.4-.4-.6-.8-1-1-1.2-38.5 22.6-82.8 36.8-131.6 42.3z"
            ></path>
          </g>
        </g>
        <g>
          <path
            fill="#020203"
            d="M663.8 585.6v27.6c0 86.4-35.6 132.4-115.9 132.4-71.7 0-113.4-44.7-115.9-124.4h71.1c2.4 38 16.5 53.9 43.5 53.9 33.1 0 44.7-19.6 44.7-63.8V588c0-44.1-18.4-57-50.9-57h-39.8v-48.4l65.6-107.9H446.8v-65.6H654V357l-73.6 118.3c53.3 5.5 83.4 54.5 83.4 110.3z"
          ></path>
          <linearGradient
            id="SVGID_00000002371739582727504260000005354005489509714063_"
            x1="431.2"
            x2="664.6"
            y1="265.35"
            y2="265.35"
            gradientTransform="translate(0 262)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#EBB794"></stop>
            <stop offset="0.472" stopColor="#682B24"></stop>
            <stop offset="0.609" stopColor="#EBB794"></stop>
            <stop offset="0.793" stopColor="#EBB794"></stop>
            <stop offset="0.957" stopColor="#C87B52"></stop>
            <stop offset="1" stopColor="#BF6C43"></stop>
          </linearGradient>
          <path
            fill="url(#SVGID_00000002371739582727504260000005354005489509714063_)"
            d="M547.9 746.4c-35.9 0-64.4-11-84.5-32.6s-31-52.8-32.2-92.6v-.9h72.7l.1.8c2.4 36.8 15.5 53.2 42.7 53.2 31.6 0 43.9-17.6 43.9-62.9v-23.3c0-39.9-14.5-56.2-50-56.2h-40.7v-49.5l64.9-106.8H445.9v-67.3h208.9v48.9l-.1.2-72.9 117.2c25 2.9 46 15.5 61 36.5 14.1 19.8 21.8 46.3 21.8 74.5v27.6c0 89.7-38.2 133.2-116.7 133.2zM432.9 622c2.7 79.2 43.5 122.8 115 122.8 77.4 0 115-43 115-131.6v-27.6c0-50.3-25.5-103.6-82.6-109.5l-1.3-.1 74.1-119.2V310H447.6v63.9h120.2l-66.2 109v47.4h39c17.8 0 30 3.9 38.2 12.2 9.1 9.2 13.5 24.1 13.5 45.6v23.3c0 23.2-3.2 38.7-10.1 48.9C575 671 563.7 676 546.7 676c-14 0-24.4-4.3-31.6-13-7.2-8.8-11.4-22.2-12.7-40.9l-69.5-.1z"
          ></path>
        </g>
      </g>
    </svg>
  );
}
